module.exports = __webpack_public_path__ + "static/media/step-indicator-2.3c710f43.svg";